<template>
<div>
    <transition-group v-if="this.$root.windowWidth >= 768" name="gridAnimation" tag="div" class="teammatesGrid">
        <teammates-card v-for="(card,index) in storedCards" :card="card" :index="index" :key="card.heading" :selectCard="selectCard"></teammates-card>
    </transition-group>
    <flickity v-else ref="flickity" :options="flickityOptions">
        <teammates-slide v-for="(card,index) in storedCards" :card="card" :index="index" :key="card.heading"></teammates-slide>
    </flickity>
</div>
</template>

<script>
import TeammatesCard from "./TeammatesCard.vue";
import TeammatesSlide from './TeammatesSlide.vue';
import Flickity from "../Flickity/Flickity.vue";

export default {
  props: ["cards"],
  data() {
    return {
      storedCards: [],
      flickityOptions: {
        wrapAround: true,
        imagesLoaded: true,
        prevNextButtons: false
      }
    };
  },
  computed: {
    windowWidth() {
      return this.$root.windowWidth;
    }
  },
  created() {
    this.storedCards = this.cards;
  },
  methods: {
    selectCard(index) {
      if (index !== 0) {
        let temp = this.storedCards.splice(0, 1, this.storedCards[index])[0];
        this.storedCards.splice(index, 1, temp);
      }
    }
  },
  components: {
    TeammatesCard,
    TeammatesSlide,
    Flickity
  }
};
</script>

<style lang="scss">
</style>

